import { render, staticRenderFns } from "./moderatorDeclined.vue?vue&type=template&id=05fceab1"
import script from "./moderatorDeclined.vue?vue&type=script&lang=js"
export * from "./moderatorDeclined.vue?vue&type=script&lang=js"
import style0 from "./moderatorDeclined.vue?vue&type=style&index=0&id=05fceab1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports